import React, { useEffect } from "react"
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

// component/showPayment/index
import ShowDetailsDashboard from "../component/dashboard/showDetailsDashboard/index";



import Layout from "../component/Layout/Layout";
import { Link } from "react-router-dom";



function IndexPage() {
    var { t } = useTranslation()
    const dispatch = useDispatch();
    const { token, login, user } = useSelector((item) => item.user)



    useEffect(() => {
        document.title = "پنل"
    }, [])

    return (
        <>
            <Layout />
            <div className="px-6 mx-auto max-w-screen-2xl sm:px-8 lg:px-16"  >

                {user.payments && user.payments.type == "DAILY" && user.payments.status == false ? (
                    <div className="p-6 text-sm font-medium text-gray-700 bg-[#16055d] border border-gray-200 rounded-lg shadow-md mt-6 mb-2">
                        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-3 place-items-center">
                            <div className="block w-full">
                                <div className="grid grid-cols-2 items-center mb-3">
                                    <div className="grid grid-cols-1">
                                        <span className="text-base font-medium text-white ">واقعیت افزوده های رایگان مانده</span>
                                        <span className="text-sm font-light text-white ">محدودیت ۱۰ بازدید به ازای هر آیتم</span>
                                    </div>
                                    <span className="text-lg font-medium text-white text-end">{user.freeNft}</span>
                                </div>
                                <div className="w-full bg-gray-300 rounded-full h-2.5">
                                    <div className="bg-red-600 h-2.5 rounded-full" style={{ width: Math.max(100 - user.freeNft * (100 / 2), 0) + "%" }}></div>
                                </div>
                            </div>
                            <div className="flex w-full justify-center"></div>
                            {
                                user.freeNft == 0 ?
                                    <div className="flex w-full justify-end">
                                        <Link to="/pay/increase">
                                            <button className=" font-medium text-sm text-white  bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300  rounded-lg   sm:w-auto px-5 py-2.5 text-center">شارژ پنل</button>
                                        </Link>
                                    </div>
                                    : null
                            }

                        </div>
                    </div>
                ) : null}


                {/* پرداختی ها ?} */}
                <ShowDetailsDashboard />
                {/* کیوار کد ها */}
                {/* <Qr /> */}
                {/* <button onClick={() => dispach(ChangeLanguage("fa"))}>ssss</button> */}
                <div className="mt-8 mb-3 " >
                    <div className="flex items-center gap-2 mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z" />
                        </svg>
                        <p className="text-sm font-medium text-gray-800">
                            {t("gallery_videos")}
                        </p>
                    </div>
                </div>
                <div className="p-6 mb-20 bg-white border border-gray-200 rounded-lg shadow-md">
                    <div className="flex flex-col items-center justify-center w-full " >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={0.5} stroke="currentColor" className="w-32 h-32 text-gray-600">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                        </svg>
                        <p>{t("video_not_found")}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IndexPage